import React from 'react';
import { Menu } from 'react-feather';
import OraLogo from '../../Global/OraLogo';
import MSMobileMenu from '../MSMobileMenu';
import { posthog } from 'posthog-js';

interface MSHeaderProps {}

const MSHeader: React.FC<MSHeaderProps> = () => {
  return (
    <>
      <header className="ms-header">
        <div className="logo-wrapper">
          <button
            className="menu-toggle"
            onClick={() => {
              const mobileMenu = document.querySelector(
                '.ms-mobile-menu_drawer'
              );
              if (mobileMenu) {
                mobileMenu.classList.add('is-open');
              }
            }}
          >
            <Menu />
          </button>
          <OraLogo type="link" url={'https://www.oraai.com/'} />
        </div>
        <div className="menu">
          <a href="https://oraai.com/team">Team</a>
          <a href="https://oraai.com/faq">FAQ</a>
          <a href="/pricing">Pricing</a>
        </div>
        <div className="links">
          <a
            className="button button--link"
            href="https://app.oraai.com/"
            type="button"
            onClick={() => {
              posthog?.capture('ms_sign_in');
            }}
          >
            Sign In
          </a>
          <a
            className="button button--glass"
            href="https://app.oraai.com/auth?signup=true"
            type="button"
            style={{ borderRadius: '100rem' }}
            onClick={() => {
              posthog?.capture('ms_sign_up', { isHero: false });
            }}
          >
            Try for Free Now
          </a>
        </div>
      </header>
      <MSMobileMenu />
      <button
        className="ms-intercom-button"
        onClick={() => {
          window.Intercom('showNewMessage');
        }}
      >
        <svg
          width="92"
          height="105"
          viewBox="0 0 92 105"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M82 0C87.5228 0 92 4.47715 92 10V105L64 93H10C4.47715 93 8.85881e-08 88.5228 0 83V10C8.3756e-07 4.47715 4.47715 1.93277e-07 10 0H82ZM78.9102 63.4629C77.5094 62.1322 75.2964 62.1884 73.9648 63.5879L73.9668 63.584L73.9365 63.6143C73.8919 63.658 73.8111 63.7355 73.6943 63.8418C73.4602 64.055 73.0806 64.3847 72.5527 64.792C71.4966 65.607 69.8485 66.7332 67.583 67.873C63.0662 70.1456 56.0397 72.5 46.25 72.5C36.4603 72.5 29.4338 70.1456 24.917 67.873C22.6515 66.7332 21.0034 65.607 19.9473 64.792C19.4194 64.3847 19.0398 64.055 18.8057 63.8418C18.6889 63.7355 18.6081 63.658 18.5635 63.6143L18.5332 63.584L18.5352 63.5869L18.5342 63.5879C17.2026 62.1889 14.9905 62.1324 13.5898 63.4629C12.1884 64.7942 12.1316 67.0087 13.4629 68.4102L16 66C13.5491 68.3284 13.4664 68.409 13.4648 68.4131L13.4746 68.4229C13.4792 68.4277 13.4844 68.4334 13.4902 68.4395C13.5018 68.4514 13.5159 68.4658 13.5322 68.4824C13.5651 68.5159 13.6079 68.5591 13.6602 68.6104C13.7649 68.7131 13.9087 68.8508 14.0918 69.0176C14.4582 69.3512 14.9833 69.8031 15.6699 70.333C17.0435 71.393 19.0676 72.767 21.7705 74.127C27.1912 76.8543 35.2897 79.5 46.25 79.5C57.2103 79.5 65.3088 76.8543 70.7295 74.127C73.4324 72.767 75.4565 71.393 76.8301 70.333C77.5167 69.8031 78.0418 69.3512 78.4082 69.0176C78.5913 68.8508 78.7351 68.7131 78.8398 68.6104C78.8921 68.5591 78.9349 68.5159 78.9678 68.4824C78.9841 68.4658 78.9982 68.4514 79.0098 68.4395C79.0156 68.4334 79.0208 68.4277 79.0254 68.4229L79.0352 68.4131C79.0336 68.409 78.9509 68.3284 76.5 66L79.0371 68.4102C80.3684 67.0087 80.3116 64.7942 78.9102 63.4629Z"
            fill="white"
            fillOpacity="0.7"
          />
        </svg>
      </button>
    </>
  );
};

export default MSHeader;
